import React from 'react'
import PropTypes from 'prop-types'
import { matchPath } from 'react-router-dom'
import { List } from '@mui/material'
import NavItem from './NavItem'

const reduceChildRoutes = ({ acc, pathname, item, depth }) => {
  const key = `${item.name}-${depth}`

  const match = item?.path ? matchPath({
    path: item.path + '*',
    exact: true,
  }, pathname) : false

  if (item.sub) {
    acc.push(
      <NavItem
        active={match ? true : false}
        depth={depth}
        icon={item.icon}
        // info={item.info}
        key={key}
        open={Boolean(match)}
        path={item.path}
        title={item.name}
        priority={item.priority}
      >
        {renderNavItems({
          depth: depth + 1,
          items: item.sub,
          pathname,
        })}
      </NavItem>,
    )
  } else {
    acc.push(
      <NavItem
        active={match ? true : false}
        depth={depth}
        key={key}
        path={item.path}
        title={item.name}
        icon={item.icon}
        priority={item.priority}
      />,
    )
  }
  return acc

}

const renderNavItems = ({ depth = 0, items, pathname }) => (
  <List disablePadding>
    {items?.reduce(
      (acc, item) =>
        reduceChildRoutes({
          acc,
          item,
          pathname,
          depth,
        }),
      [],
    )}
  </List>
)

const NavSection = (props) => {
  const { name, path, pathname, sub, ...other } = props
  return (
    <List disablePadding sx={{ margin: "0px" }}
      {...other}
    >
      {renderNavItems({
        items: sub,
        pathname,
      })}
    </List>
  )
}

NavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string,
  title: PropTypes.string,
}

export default NavSection
